import React from 'react';

class TeamDropdown extends React.Component {

  constructor(props) {
		super(props);
		this.teamChange = this.teamChange.bind(this);
		this.createSelectItem = this.createSelectItem.bind(this);
	}

	teamChange(event) {
		var teamNumber = event.target.name.charAt(1);
		this.props.teamChange(event.target.value, teamNumber);
	}

	render() {
		//console.log('TeamDropdown: render')
		return (
			<select className="form-control" value={this.props.value} onChange={this.teamChange} name={this.props.teamNumber}>
				{this.props.teams.map(this.createSelectItem)}
			</select>
		);
	}

	createSelectItem(team) {
		return (
			<option value={team._id} key={team._id}>{team.name}</option>
		);
	}

}

export default TeamDropdown;